import { InputLabelSelect } from "../../components/inputLabel";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import preCadastroActions from "../../redux/preCadastro/actions";
import { StoreState } from "../../redux/reduxTypes";
import { PreCadastroState } from "../../types/state.types";
import { DivisoriaSecao, TituloSecao } from "./styled";
import { formatData } from "../../utils/functions-helper";

function Agendamento() {
  const dispatch = useDispatch();

  const { dados, listaDatasAtendimento, listaHorariosAtendimento } =
    useSelector<StoreState, PreCadastroState>(
      (state) => state.preCadastroState
    );

  const atualizarDadosPreCadastro = useCallback(
    (dadosForm: object) => {
      dispatch(
        preCadastroActions.setDados({
          ...dados,
          ...dadosForm,
        })
      );
    },
    [dados, dispatch]
  );

  const buscarHorariosAtendimento = useCallback(
    (data: string) => {
      dispatch(preCadastroActions.buscarHorariosAtendimento(data));
    },
    [dispatch]
  );

  return (
    <DivisoriaSecao>
      <TituloSecao>Agendamento</TituloSecao>

      <InputLabelSelect
        labelText="Data do Agendamento"
        labelId="dataAgendamento"
        value={dados.dataAgendamento}
        onChange={(value) => {
          atualizarDadosPreCadastro({
            dataAgendamento: value,
            horarioAgendamento: undefined,
          });

          if (value) {
            buscarHorariosAtendimento(value);
          }
        }}
        required
        options={
          listaDatasAtendimento
            ? [
                {
                  value: "",
                  label: "(( SELECIONAR )) ",
                },
                ...listaDatasAtendimento.map((item) => {
                  return {
                    value: item,
                    label: formatData(item),
                  };
                }),
              ]
            : []
        }
        column
      />

      <InputLabelSelect
        labelText="Horário Agendamento"
        labelId="horarioAgendamento"
        value={dados.horarioAgendamento}
        onChange={(value) => {
          atualizarDadosPreCadastro({ horarioAgendamento: value });
        }}
        required
        options={
          listaHorariosAtendimento
            ? [
                {
                  value: "",
                  label: "(( SELECIONAR )) ",
                },
                ...listaHorariosAtendimento.map((item) => {
                  return {
                    value: item,
                    label: item.substring(11, 16),
                  };
                }),
              ]
            : []
        }
        column
      />
    </DivisoriaSecao>
  );
}

export default Agendamento;
